<template>
    <div class="text-darkGrayishBlue">
        <div
            class="font-semibold text-xl my-2 flex flex-row justify-center items-center"
        >
            繼續付款
            <img class="w-16" :src="fpsImg" />
        </div>
        <div class="w-full font-semibold">
            <fieldset class="border">
                <legend class="ml-4">付款資料</legend>
                <div class="mx-2 sm:mx-16 my-4">
                    <div class="mb-2 flex">
                        <div class="w-24 sm:w-40 flex-shrink-0">商戶:</div>
                        <div>MillionTech Development Limited</div>
                    </div>
                    <div class="mb-2 flex">
                        <div class="w-24 sm:w-40 flex-shrink-0">付款金額:</div>
                        <div>{{ paymentAmount | price(true, 'HKD') }}</div>
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="flex flex-wrap justify-center items-center mt-2">
            <div class="flex flex-col">
                <qrcode :value="qrcode" :options="{ width: 300 }" />
                <div class="text-sm font-bold bg-gray-100 text-center">
                    請在10分鐘內完成交易，否則二維碼將會失效
                </div>
            </div>
            <div class="text-sm flex-grow ml-4">
                <div class="mb-8">步驟:</div>
                <div class="mb-8">
                    1)
                    請開啟支援「轉數快」及新發布的業界通用二維碼標準的支付應用程式
                </div>
                <div class="mb-8">2) 掃瞄二維碼並以轉數快完成付款</div>
                <div class="mb-8">
                    3) 完成交易後，頁面會自動顯示訂單確認資訊。
                </div>
            </div>
        </div>
        <div class="flex flex-row justify-between">
            <button
                class="btn border-blue text-blue mt-4"
                @click="showCancelPayment = true"
            >
                取消
            </button>

            <template v-if="$config.testingConfig.showFpsSimulationBtn()">
                <button
                    v-if="!sentMarkAsSuccessRequest"
                    class="btn border-4 border-red text-red mt-4"
                    @click="simulatePayment"
                >
                    Success (Fps Simulation)
                </button>
                <div v-else>
                    {{ 'Please wait for fps notification callback' }}
                </div>
            </template>
            <button
                v-if="$config.testingConfig.showFpsFailBtn()"
                class="btn border-4 border-blue text-blue mt-4"
                @click="cancel"
            >
                Fail (Fake)
            </button>
            <modal
                type="confirm"
                :cancelText="$t('common.cancel')"
                :confirmText="$t('common.confirm')"
                v-if="showCancelPayment"
                @confirm="
                    () => {
                        this.showCancelPayment = false;
                        this.cancel();
                    }
                "
                @cancel="
                    () => {
                        this.showCancelPayment = false;
                    }
                "
            >
                <div class="text-darkGrayishBlue">
                    {{ '是否取消付款?' }}
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
import fpsImg from '@/assets/img/payment_fps_md.png';
import price from '@/components/priceFilter';
import qrcode from '@/components/qrcode.vue';
import { instance } from '@/utils/ajax';
import modal from '@/components/modal.vue';

async function fpsPaymentSimulation(orderKey) {
    try {
        let result = await instance.post('/api/payment/fps/simulation', {
            saleOrdKey: orderKey
        });
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error fpsPaymentSimulation');
        return { success: false, all: 'error.connect' };
    }
}

async function fpsPaymentCancellation(orderKey) {
    try {
        let result = await instance.post('/api/payment/fps/cancelPayment', {
            saleOrdKey: orderKey
        });
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error fpsPaymentCancellation');
        return { success: false, all: 'error.connect' };
    }
}

export default {
    components: { qrcode, modal },
    data: () => ({
        interval: undefined,
        showCancelPayment: false,
        sentMarkAsSuccessRequest: false
    }),
    computed: {
        qrcode() {
            return this.$store.state.fpsQrCode;
        },
        paymentAmount() {
            return this.$store.state.fpsPymtAmt;
        },
        orderNo() {
            return this.$store.state.fpsCurrentOrdNo;
        },
        orderKey() {
            return this.$store.state.fpsCurrentOrdKey;
        }
    },
    filters: {
        price
    },
    created() {
        this.fpsImg = fpsImg;

        // Refresh Sales Order's status
        const refreshPeriodSecond = 5;
        if (this.orderNo) {
            this.interval = setInterval(async () => {
                const order = await this.$store.dispatch(
                    'getOrderDetails',
                    this.orderNo
                );
                if (order && order.saleOrdStsCode !== 'P')
                    this.navigateToOrderDetail();
            }, refreshPeriodSecond * 1000);
        }
    },
    beforeDestroy() {
        // Clear Fps QR Code before leaving this page
        this.$store.commit('setFpsData', {});
        if (this.interval) clearInterval(this.interval);
    },
    methods: {
        async simulatePayment() {
            if (this.orderKey) {
                const result = await fpsPaymentSimulation(this.orderKey);
                if (result.success) this.sentMarkAsSuccessRequest = true;
            }
        },
        async cancel() {
            if (this.orderKey) {
                const result = await fpsPaymentCancellation(this.orderKey);
                if (result.success) {
                    this.navigateToOrderDetail();
                    this.$store.dispatch('getShoppingCartList');
                }
            }
        },
        navigateToOrderDetail() {
            this.$router.push({
                name: 'order',
                params: {
                    orderNo: this.orderNo
                },
                query: {
                    success: 'true'
                }
            });
        }
    }
};
</script>
